import { render } from "./FooterCalculation.vue?vue&type=template&id=28d254a1"
import script from "./FooterCalculation.vue?vue&type=script&lang=js"
export * from "./FooterCalculation.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/vue-calendar-bundle-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__